<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/kinara_logo.svg"
                alt="register"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="px-8 register-tabs-container">
                <!-- <div class="vx-card__title mb-4">
                  <h4>Create Account</h4>
                  <p>Fill the below form to create a new account.</p>
                </div> -->
                <register-jwt></register-jwt>
                <!-- <vs-tabs>
                                  <vs-tab label="JWT">
                                    <register-jwt></register-jwt>
                                  </vs-tab>

                                  <vs-tab label="Firebase">
                                    <register-firebase></register-firebase>
                                  </vs-tab>

                                  <vs-tab label="Auth0">
                                    <register-auth0></register-auth0>
                                  </vs-tab>
                                </vs-tabs> -->
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import RegisterJwt from './RegisterJWT.vue'
import RegisterFirebase from './RegisterFirebase.vue'
import RegisterAuth0 from './RegisterAuth0.vue'

export default {
  components: {
    RegisterJwt,
    RegisterFirebase,
    RegisterAuth0
  }
}
</script>

<style lang="scss">
.register-tabs-container {
  padding: 2rem 0;
  .vx-card__title{
    h4 {
      font-size: 24px;
      font-family: "Poppins", Sans-serif;
      color: #062339;
      margin-bottom:10px;
    }
    p {
    display: block;
    color: #062339;
    font-family: "Poppins", Sans-serif;
    font-size: 16px;
    line-height: 20px;
    }
  }
    p {
      display: block;
      color: #062339;
      font-family: "Poppins", sans-serif;
      font-size: 12px;
    }
  .con-vs-checkbox{margin-left: 0px;margin-bottom: 1.25rem !important;}
}
.registerwrap {
  .vs-input {
    // padding-top: 15px;
  }
  .con-select {
    width: 100%;
  }
  .form_input {
    padding: 0.7rem !important;
    height: auto;
  }
}
.layout--full-page .bg-img {
  height: auto !important;
  min-height: 100vh !important;
  padding: 20px 0;
}
</style>
